import AddNewButton from 'Components/Generic/Buttons/AddNewButton';
import { SITE_PAGES } from 'Config';
import SiteDrawerData from 'Data/SiteDrawerData';
import AdminLanding from './AdminLanding';
import UserDetails from './Users/UserDetails';
import UserListView from './Users/UserListView';

const ManageUsersView = () => {
  let breadcrumb = [SITE_PAGES.MANAGE_USERS];

  let drawerContent = (
    <UserDetails editable hideToggle parentEditState={true} />
  );
  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: 'New User',
    });
  };

  let addNewButton = (
    <AddNewButton buttonText='Add User' clickHandler={onClick} tableButton />
  );

  return (
    <AdminLanding breadcrumbs={breadcrumb}>
      <UserListView addNewUserButton={addNewButton} />
    </AdminLanding>
  );
};

export default ManageUsersView;
